import React, { Component } from 'react';
import NavButton from '../component/NavButton.js';

export default class ASMUserNav extends Component{
	constructor(props){
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.state = {current:'Shop'}
	}

	handleClick(navTo){ //method that passes up the page selected based on the nav button that has been clicked
		this.props.navClick(this.state.current,navTo);
		this.setState({current:navTo});
	}

	render(){
		let manager;
		const buttonstyle = "dim b w-100 pt2 pb2 white bg-navy bn ml1 mr1 pointer";
		let divStyle = "fl w-33 bl pl1 pr1 b--white asmUserNav";
		let firstDivStyle = "fl w-33";
		if (this.props.user !== "asm"){
			if(this.props.user !== "asm_regional"){
				divStyle = "fl w-50 pl1 pr1 asmUserNav";
			}else{
				divStyle = "fl w-25 bl b--white asmUserNav";
			}
			 manager = <div className={divStyle}><NavButton name="Budgeting" onClick={this.handleClick} styles={buttonstyle}/></div>;
			 firstDivStyle = "fl w-25";
		}
		let buttons;
		if(this.props.user !== "asm" && this.props.user !== "asm_regional"){
			divStyle = "fl w-50 bl pl1 pr1 b--white asmUserNav";
			buttons = <div className="fl w-100 bg-navy">
							{manager}
							<div className={divStyle}>
								<button onClick={this.props.logout} className={buttonstyle}>Logout</button>
							</div>
						</div>;
		}else{
			buttons = <div className="fl w-100 bg-navy">
						<div className={firstDivStyle}>
							<NavButton name="Shop" styles={buttonstyle} onClick={this.handleClick}/>
						</div>
						<div className={divStyle}>
							<NavButton name="Order History" styles={buttonstyle} onClick={this.handleClick}/>
						</div>
						{manager}
						<div className={divStyle}>
							<button onClick={this.props.logout} className={buttonstyle}>Logout</button>
						</div>
					</div>;
		}
		return(
			<div>
			{buttons}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/container/ASMUserNav.js